<template>
  <nuttrema-layout-content>
    <template slot="header">
      <persons-standard-header
        :meta="meta"
        :PersonDetails="PersonDetails">
        <template slot="edit">
          <div class="content-header-item">
            <permissions-control-wrapper
              :required-general="$PERMISSIONS_GENERAL.EDIT_PROFILE"
              :permissions="_get(PersonDetails, 'meta.permissions')">
              <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
              <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
            </permissions-control-wrapper>
          </div>
        </template>
      </persons-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="PersonDetails.fetching"></nuttrema-loader>
      <form-person-profile-picture
         v-else
        :edit.sync="edit"
        :PersonDetails="PersonDetails"
        @uploadProfilePicture="uploadProfilePicture"
        @removeProfilePicture="removeProfilePicture"
        @uploadProfilePictureSuccess="handleUploadProfilePictureSuccess">
      </form-person-profile-picture>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import PersonsStandardHeader from 'components/pages/professional/persons/participants/shared/blocks/cmpt-persons-standard-header';
import PagePersonProfilePicture from 'components/pages/professional/persons/shared/profile-picture/page-person-profile-picture';

export default {
  name: 'participant-profile-picture',
  mixins: [PagePersonProfilePicture],
  components: {
    PersonsStandardHeader,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/profile-picture/page-participant-profile-picture.vue